module.exports = __webpack_public_path__ + "img/team-placeholder.395a5381.png";